import { ABAC_RULES } from '../../modules/ac/constants'
import { buildRbacRulesForRole } from '../../modules/ac/rbacRules'
import { rolesArrayToMap } from '../../modules/ac/assignableRoles'
import { createReducer } from '../../modules/utilities/store'
import AC_TYPES from '../types/AC'
import GLOBAL_TYPES from '../types/Global'

const initialState = {
  rulesPopulated: true,
  roleId: null,
  permissionKeys: [],
  roles: [],
  rolesById: {},
  rules: {
    ...ABAC_RULES
  }
}

const handlers = {
  [AC_TYPES.SET_PERMISSIONS]: (state, action) => {
    const { roleId, permissionKeys } = action.data
    return {
      ...state,
      rulesPopulated: true,
      roleId,
      permissionKeys: permissionKeys || [],
      rules: buildRbacRulesForRole(roleId, permissionKeys || [])
    }
  },
  [AC_TYPES.SET_ROLES]: (state, action) => {
    const roles = action.data.roles || []
    return {
      ...state,
      roles,
      rolesById: rolesArrayToMap(roles)
    }
  },
  [AC_TYPES.CLEAR_PERMISSIONS]: () => initialState,
  [GLOBAL_TYPES.RESET_STORE]: () => initialState
}

const AC = createReducer(initialState, handlers)

export default AC
